import { render, staticRenderFns } from "./NSelect.vue?vue&type=template&id=19159dc8"
import script from "./NSelect.vue?vue&type=script&lang=ts"
export * from "./NSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports